<template>
    <div>
      <Modal
            class-name="vertical-center-modal"
            :value="showModel"
            :title="title"
            :footer-hide="true"
            :mask-closable="false"
            @on-cancel="cancel"
            @on-visible-change="openOrClose"  :styles="{'min-width':'700px'}">
            <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80" inline>
    
     
                 <FormItem :label="$t('BasicProduct.comTypeBox.up')"  prop="up" class="ivu-form-item-required"  style="width: 560px">
                    <CheckboxGroup v-model="formData.up" @on-change="changeVal($event,'up')">
                        <Checkbox v-for="item in selectObj.modeList" :key="item.id"  :label="item.val">
                            <span>{{item.val}}</span>
                        </Checkbox>
                    </CheckboxGroup>
                </FormItem>

                 <FormItem :label="$t('BasicProduct.comTypeBox.down')"  prop="down" class="ivu-form-item-required"  style="width: 560px">
                    <CheckboxGroup v-model="formData.down" @on-change="changeVal($event,'down')">
                        <Checkbox v-for="item in selectObj.modeList" :key="item.id"  :label="item.val">
                            <span>{{item.val}}</span>
                        </Checkbox>
                    </CheckboxGroup>
                </FormItem>
    
          

                <div class="flexCC">
                  <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                  <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
                </div>
              
            </Form>
    
        </Modal>
    
    </div>
    
    </template>
    <script>
    /**
     * 弹框
     * @param showModel boolean 对话框开关 true false
     * @param fn function 回调函数
     * @param type Number 类型 1添加 2编辑
     * @param editFormData Object 编辑时的数据
     */
    import common from '@/common/common';
    import moment from 'moment';
    import { mapState } from 'vuex'
    
    
        export default {
            props: {
                editFormData:Object,
                showModel: Boolean,
                fn:Function,
                type:Number
            },
            name: "Model3",
            components: {
            },
            data() {
                return {   
                    disabled: false,//禁用确定按钮
                    // title: '',//弹框标题
                    formData: {//表单数据
                        up:[],//基础型号的名称
                        down:[],//基础分类编号
                    }
                }
            },
           
            computed:{
                 ...mapState(['local','selectId']),
                 title(){
                    let title = this.$t('BasicProduct.titleName.comType')
                    return title
                 },
                ruleCustom(){
                    return {
                        up: [
                           {required: true, type: 'array', min: 1, message: this.$t('required'),trigger: 'change' },
                        ],
                        down: [
                           {required: true, type: 'array', min: 1, message: this.$t('required'),trigger: 'change' },
                        ]
                    }
                },
                selectObj(){
                    return {
                        modeList:[
                            {id: 'WIFI',val:'WIFI'},
                            {id: 'CELL',val:'CELL'},
                            {id: 'LAN',val:'LAN'},
                            {id: 'LoRaWan',val:'LoRaWan'},
                            {id: 'LoRaDTU',val:'LoRaDTU'},
                            {id: 'LoRaAC',val:'LoRaAC'},
                            {id: 'BLE',val:'BLE'},
                            {id: 'BLE5',val:'BLE5'},
                            {id: 'BLEMesh',val:'BLEMesh'},
                            {id: 'RS485',val:'RS485'},
                            {id: 'None',val:'None'},
                        ]
     
                    }
                },
    
            },
            created(){
           
            },
            mounted(){
            },
            watch:{
                showModel(val){
                    if(val === true) {   
                       if(this.editFormData['UP'] && this.editFormData['UP'].length){
                        this.formData.up = common.deepClone(this.editFormData['UP'])
                        this.formData.down = common.deepClone(this.editFormData['DOWN'])
                       }
                    }else{
                        this.resetForm()
                    }
                },
               
            },
            methods: {
                openOrClose(){},
                changeVal(data,key){
                    if(data.includes('None')){
                        this.formData[key] = ['None']
                    }
                },
                subData(name) {//提交表单
                    this.$refs[name].validate((valid) => {
                        if(valid){
                            let res = 
                                {
                                    "up": common.deepClone(this.formData.up),
                                    "down":common.deepClone(this.formData.down)
                                }
                            this.fn(res)
                        }
                    })
                },
                cancel() {//对话框关闭
                    this.resetForm();//重置表单
                    this.$emit('update:showModel',false);
                },
                resetForm() {//重置表单
                    this.$refs.formData.resetFields();//重置表单
                }
            }
        }
    </script>
    
    <style lang='less' scoped>
    .simple-size {
        color: #ccc;
        font-size: 12px;
        height: 20px;
        padding: 0;
        margin: 0;
    }
    /deep/ .vertical-center-modal{
        display: flex;
        align-items: center;
        justify-content: center;
        .ivu-modal{
            top: 0;
        }
       
    }
    
    /deep/ .ivu-input-number{
        width: 100% !important;
    }
    .verAddCon{
        position: relative;
        .title{
            font-size: 20px;
            padding: 4px 0 20px;
        }
        .colseButton{
            position: absolute;
            right: -18px;
            top:-18px
        }
        // .ivu-layout-content{
        //    min-width: 680px !important;
        //    overflow-x: scroll;
        // }
    }
     /deep/ .ivu-form-item-content{
          margin-left: 176px !important;
          flex-grow: 1;
      }
    .logoCon{
      /deep/ .ivu-form-item-content{
          margin-left: 0px !important;
      }
    }
     /deep/ .ivu-form .ivu-form-item-label{
        width: 162px !important;
    }
    </style>
    